import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslationMessages from './translations/en.json';
import deTranslationMessages from './translations/de.json';
import frTranslationMessages from './translations/fr.json';
import ptTranslationMessages from './translations/pt.json';
import esTranslationMessages from './translations/es.json';
import zhTranslationMessages from './translations/zh.json';

const resources = {
  en: { translation: enTranslationMessages },
  de: { translation: deTranslationMessages },
  fr: { translation: frTranslationMessages },
  pt: { translation: ptTranslationMessages },
  es: { translation: esTranslationMessages },
  zh: { translation: zhTranslationMessages },
};

// Ensure we fallback to 'en' if no language preference exists in localStorage or on the user's browser.
const userLanguage = localStorage.getItem('locale') || navigator.language.split('-')[0] || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: userLanguage,  // Set the initial language based on localStorage or browser language
    fallbackLng: 'en',  // Fallback to English if the selected language is not available
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
